import { Component } from '@angular/core';
import { PRIMENG_MODULES } from '../../primeng-imports';
import { MsalService } from '@azure/msal-angular';
import { ActivatedRoute } from '@angular/router';
import { AUTH_BUTTON_LABELS } from '../../auth-button-labels';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [...PRIMENG_MODULES]
})
export class LoginComponent {
  readonly authButtonLabels = AUTH_BUTTON_LABELS;
  accessDeniedVisible = false;
  isSigningIn = false;
  readonly accessDeniedMessage =
    'You are not authorized to access the Modern List page. Please contact your administrator.';

  constructor(
    private msalService: MsalService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.accessDeniedVisible = this.route.snapshot.queryParamMap.get('accessDenied') === '1';
  }

  async login() {
    if (this.isSigningIn) {
      return;
    }

    this.isSigningIn = true;
    try {
      sessionStorage.clear();
      await this.msalService.loginRedirect();
    } catch (error) {
      this.isSigningIn = false;
      console.error('MSAL redirect login failed', error);
    }
  }

  onAccessDeniedOk() {
    this.accessDeniedVisible = false;
    this.msalService.logoutRedirect();
  }
}
